"use-strict";

export default {
  SET_ALL_STANDINGS: "@@standings/SET_ALL_STANDINGS",
  CLEAR_ALL_STANDINGS: "@@standings/CLEAR_ALL_STANDINGS",
};
